import { MenuItem } from "@remo-co/ui-core/src/components/MenuItem";

interface Props {
  className?: string;
  handleAction: (e: React.MouseEvent) => void;
  icon: React.ReactElement;
  actionTitle: string;
}

export const SpaceActionButton = ({
  className,
  handleAction,
  icon,
  actionTitle,
}: Props): JSX.Element | null => (
  <MenuItem className={className} onClick={handleAction}>
    {icon}
    {actionTitle}
  </MenuItem>
);
